<ng-template #Checkmark let-selected="selected" let-passId="passId">
    <div class="checkmark">
        <div class="checkmark_circle" [ngClass]="selected?.id === passId ? 'circle_vanish' : ''"></div>
        <div class="checkedmark" [ngClass]="selected?.id === passId ? '' : 'unchecked'">
            <img class="checkmark-img" src="/assets/icons/tick_mark.svg" width="18px" height="18px" alt="Tickmark" />
        </div>
    </div>
</ng-template>

<section [ngClass]="brandingPageRequest ? 'remove-padding' : ''">
    @if (!brandingPageRequest) {
        <mat-icon aria-hidden="true" class="close" (click)="close()"> clear </mat-icon>
    }
    @if (!(requestFromCart || brandingPageRequest)) {
        <div class="branding-background"></div>
    }
    <div class="page-content" [ngClass]="!(requestFromCart || brandingPageRequest) ? 'transform' : ''">
        @if (!brandingPageRequest) {
            <div class="brand-info">
                @if (!requestFromCart) {
                    <div class="download">
                        <div class="download-text">Avail benefits on Partner Brands</div>
                        <div class="download_link">
                            <app-install-eatclub [type]="'small'"></app-install-eatclub>
                        </div>
                    </div>
                }
                @if (requestFromCart) {
                    <div>
                        <div class="heading-cart">
                            <p>Select Your</p>
                            <b> EatClub Membership</b>
                        </div>
                        <div class="membership-details">
                            <div class="membership-details-content">
                                <div class="membership-content">
                                    <img
                                        class="membership-content-img"
                                        src="/assets/icons/tick_mark.svg"
                                        width="15px"
                                        alt="Tickmark" />
                                    Flat 30% OFF Everytime
                                </div>
                                <div class="membership-content">
                                    <img
                                        class="membership-content-img"
                                        src="/assets/icons/tick_mark.svg"
                                        width="15px"
                                        alt="Tickmark" />
                                    ZERO Delivery/Packaging Fees
                                </div>
                                <div class="membership-content">
                                    <img
                                        class="membership-content-img"
                                        src="/assets/icons/tick_mark.svg"
                                        width="15px"
                                        alt="Tickmark" />
                                    Handpicked Brands ONLY
                                </div>
                            </div>
                            @if (customerSavings) {
                                <div class="membership-data savings-data">
                                    <div class="membership-data-label">&#8377;&nbsp;{{ customerSavings }}</div>
                                    <div class="membership-data-desc">SAVED SO FAR</div>
                                </div>
                            }
                        </div>
                    </div>
                }
                @if (!requestFromCart) {
                    <div class="layout">
                        <div class="heading">
                            <p>Welcome to</p>
                            <img src="{{ DEPLOY_URL }}/assets/images/membership_logo.png" width="100px" alt="EatClub Logo" />
                        </div>
                        @for (info of branding_text; track info) {
                            <div class="branding-text">
                                <div class="branding-text-icon">
                                    <img class="branding-text-img" [src]="info?.icon" />
                                </div>
                                <div class="branding-text-content">
                                    <div class="branding-text-content-heading">{{ info?.heading }}</div>
                                    <div class="space-10"></div>
                                    <div class="branding-text-content-body">{{ info?.body }}</div>
                                </div>
                            </div>
                        }
                    </div>
                }
            </div>
        }

        <div class="brand-products" [ngClass]="brandingPageRequest ? 'remove-padding' : ''">
            @if (passAvailable) {
                <div class="memberships">
                    @if (!isMobile) {
                        <div class="memberships-heading">
                            <div class="memberships-heading-beginning">Select Your</div>
                            <div class="memberships-heading-brand-tag">EatClub Membership</div>
                        </div>
                    }
                    @if (!requestFromCart) {
                        <h3 class="memberships-heading-mobile">
                            Select Your Membership
                            <hr />
                        </h3>
                    }
                    @if (isDefaultOutlet) {
                        <div class="text-center" style="margin: 1rem 0">
                            We are <span style="color: #ff5500"> not available</span> at this location
                        </div>
                    }
                    <div class="memberships-content" [ngClass]="isDefaultOutlet ? 'disabled' : ''">
                        <div class="membership-info">
                            <div class="membership-data">
                                <div class="membership-data-desc mem-details">
                                    <div class="membership-usps">
                                        <img src="/assets/icons/tick_mark.svg" width="15px" alt="Tickmark" />
                                        No HIDDEN fees EVER
                                    </div>
                                    <div class="membership-usps">
                                        <img src="/assets/icons/tick_mark.svg" width="15px" alt="Tickmark" />
                                        Save 30% Everytime
                                    </div>
                                    <div class="membership-usps">
                                        <img src="/assets/icons/tick_mark.svg" width="15px" alt="Tickmark" />
                                        Handpicked brands ONLY
                                    </div>
                                </div>
                            </div>
                            @if (customerSavings) {
                                <div class="membership-data membership-savings-data">
                                    <div class="membership-data-label">&#8377;&nbsp;{{ customerSavings }}</div>
                                    <div class="membership-data-desc">SAVED SO FAR</div>
                                </div>
                            }
                        </div>
                        <div class="product-layout">
                            @for (pass of passes; track pass) {
                                <div
                                    class="membership-data memberships-products"
                                    (click)="selectPass(pass)"
                                    [ngClass]="{
                                        selected: isSelected(pass),
                                        'disabled expired-trial': eatclubTrialExpired && pass?.trial
                                    }">
                                    @if (pass.id === cartPass?.id) {
                                        <div class="already-in-cart">Already in cart</div>
                                    }
                                    @if (pass.id !== cartPass?.id && pass.id === bestValuePass['bestPassId']) {
                                        <div class="best-value">Best Value</div>
                                    }
                                    <div class="passes-layout">
                                        <div class="pass-container">
                                            <ng-template
                                                [ngTemplateOutlet]="Checkmark"
                                                [ngTemplateOutletContext]="{ passId: pass.id, selected: selected }">
                                            </ng-template>
                                            @if (pass?.discounted_price) {
                                                <div class="pass-price">&#8377;&nbsp;{{ pass?.discounted_price }}</div>
                                            } @else {
                                                <div class="pass-price green">Free</div>
                                            }
                                            <div style="height: 17px">
                                                @if (!pass?.trial && pass?.price) {
                                                    <div
                                                        class="pass-price-without-discount"
                                                        style="text-decoration-line: line-through">
                                                        &#8377;&nbsp;{{ pass?.price }}
                                                    </div>
                                                }
                                                @if (pass?.trial) {
                                                    <div #freePassDetails>
                                                        <div class="pass-price-without-discount">Trial</div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        @if (!showDownloadEatclub(pass)) {
                                            <div class="validity-margin">
                                                {{ pass?.expiry_text }}
                                            </div>
                                        } @else {
                                            <div class="validity-margin">{{ pass?.expiry_text }}</div>
                                            <div class="download-eatclub">
                                                Only On
                                                <div class="bolder">EatClub App</div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    <div class="mem-page-text">
                        <div class="mem-page-content mem-page-total-users">1M+</div>
                        <div class="mem-page-content">users are enjoying EatClub. It's your turn now!</div>
                    </div>
                    <div class="action apply-eatclub-btn">
                        <ng-container>
                            <button
                                btn-primary
                                class="btn"
                                style="background-color: #0c0d0d"
                                (click)="clickAction()"
                                [disabled]="showLoader"
                                [isLoading]="showLoader">
                                <div style="text-transform: none">
                                    {{ ctaState }}
                                </div>
                            </button>
                        </ng-container>
                    </div>
                </div>
            }

            @if (!passAvailable) {
                <div class="action">
                    <button class="btn" (click)="exploreBrands()">Explore Brands</button>
                </div>
            }
        </div>

        @if (!requestFromCart && isMobile && !brandingPageRequest) {
            <div class="brand-on-board">
                <div class="brands-container">
                    <div class="brands-info">
                        <div class="brands-heading">Brands On Board</div>
                        <div class="brands-description">Enjoy access to offers on these exclusive brands for the next month!</div>
                    </div>
                    <div class="icons-container">
                        @for (icon of brand_icons; track icon) {
                            <div class="icons">
                                <img imageSrc="{{ icon }}" appDeferImageLoad />
                            </div>
                        }
                    </div>
                </div>
            </div>
            <div class="download-bottom">
                <div class="space-20"></div>
                <div class="download-bottom-text">
                    Avail benefits on Partner Brands
                    <app-install-eatclub [type]="'large'"></app-install-eatclub>
                </div>
            </div>
        }
    </div>
</section>
